var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SNS logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    width: 32,
    height: 32,
    rx: 6,
    fill: "#007AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M11.4087 23.7945C9.11378 22.5065 7.5694 20.3589 7.03714 18.0224C6.81524 17.0828 7.61766 16.1358 8.64197 16.1285L15.0647 16.1235C15.6703 16.1141 16.2103 16.4171 16.5047 16.9317L19.7116 22.3412C20.2623 23.2325 19.7748 24.3562 18.7558 24.6576C16.3441 25.2836 13.7036 25.0825 11.4087 23.7945ZM23.408 15.9155L16.9852 15.9205C16.3797 15.93 15.8397 15.6269 15.5453 15.1124L12.3384 9.70281C11.8327 8.83682 12.2492 7.73149 13.2232 7.40482C15.5709 6.68467 18.2564 6.91101 20.5513 8.19901C22.8462 9.48701 24.3906 11.6346 24.9228 13.9711C25.2538 15.0302 24.4773 15.9334 23.408 15.9155Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78f19e4abebca76ae7261c5567ed42d3.svg";
export { ForwardRef as ReactComponent };